
import { UserButton } from '@/components/auth/UserButton';
import { Button } from '@/components/ui/button';
import { ModeToggle } from '@/components/ui/mode-toggle';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { useAuth } from '@/contexts/auth/AuthContext';
import { SidebarTrigger } from '@/components/ui/sidebar';
import OrganizationSelector from '@/components/organizations/OrganizationSelector';
import { Badge } from '@/components/ui/badge';
import { Link } from 'react-router-dom';

const Header = () => {
  const { user, currentOrganization, isFounder } = useAuth();

  // Helper function to get role label
  const getRoleLabel = (role: string) => {
    switch (role) {
      case 'primary_founder':
        return 'Primary Founder';
      case 'co_founder':
        return 'Co-Founder';
      case 'department_head':
        return 'Department Head';
      case 'team_member':
        return 'Team Member';
      default:
        return role;
    }
  };

  return (
    <header className="border-b bg-background">
      <div className="flex h-16 items-center px-4 gap-4">
        <div className="flex items-center justify-center">
          <SidebarTrigger className="h-9 w-9 flex items-center justify-center" />
        </div>
        
        <div className="md:hidden flex-1 text-center">
          <strong className="text-lg">Founders CRM</strong>
        </div>
        
        {user && (
          <>
            <div className="hidden md:block w-full md:w-[200px]">
              <OrganizationSelector />
            </div>
            
            <div className="hidden md:block relative flex-1 md:flex-initial md:w-[400px] mx-4">
              <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
              <Input
                type="search"
                placeholder="Search..."
                className="w-full bg-background pl-8"
              />
            </div>
            
            {currentOrganization && (
              <div className="hidden md:flex items-center">
                <Badge variant="outline" className="ml-2">
                  {getRoleLabel(currentOrganization.role)}
                </Badge>
              </div>
            )}
          </>
        )}
        
        <div className="ml-auto flex items-center gap-2">
          <ModeToggle />
          {user ? (
            <UserButton />
          ) : (
            <Link to="/signin">
              <Button variant="ghost" size="sm">Log in</Button>
            </Link>
          )}
        </div>
      </div>
      
      {/* Mobile menu items */}
      {user && (
        <div className="md:hidden border-t px-4 py-2 flex flex-col space-y-2">
          <div className="w-full">
            <OrganizationSelector />
          </div>
          {currentOrganization && (
            <div className="flex items-center justify-between">
              <Badge variant="outline">
                {getRoleLabel(currentOrganization.role)}
              </Badge>
              <div className="relative flex-1 max-w-sm ml-2">
                <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
                <Input
                  type="search"
                  placeholder="Search..."
                  className="w-full bg-background pl-8"
                />
              </div>
            </div>
          )}
        </div>
      )}
    </header>
  );
};

export default Header;
